import React, { Component } from "react";
import _ from "lodash";

class TableBody extends Component {
  renderCell = (item, column) => {
    // 2020-10-28
    //if (column.content) return column.content(item);
    if (column.content) return column.content(_.get(item, column.path));

    // 2020-10-28
    //return _.get(item, column.path);
    if (column.path === 'nome_completo') {
      const str_nome_completo = _.get(item, column.path)
      const arr__nome_completo = str_nome_completo.split(' ');
      return arr__nome_completo[0] + ' ' + arr__nome_completo[arr__nome_completo.length -1 ]; // primeiro nome + ' ' + último nome
    } else {
      return _.get(item, column.path);
    }
  };

  createKey = (item, column) => {
    return item._id + (column.path || column.key);
  };

  render() {
    const { data, columns } = this.props;

    return (
      <tbody>
        {data.map(item => (
          <tr key={item._id}>
            {columns.map(column => (
              <td key={this.createKey(item, column)}>
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;
